module.exports = __webpack_public_path__ + "img/20260115.b966a7c5.png";